import React from 'react';
import PropTypes from 'prop-types';
import PasswordField from './PasswordField';

export const RenderPasswordField = ({
  name,
  icon,
  label,
  input,
  meta: {
    touched,
    error,
    active,
  },
}) => (
  <label htmlFor={name} id={`${name}_label`} className="label">
    {label}
    <div className="control has-icons-left has-icons-right custom-password-field">
      <PasswordField
        {...input}
        className={`input is-medium${(active || touched) && error ? ' is-danger' : ''}`}
        required="required"
        type="password"
      />
      <span className="icon is-small is-left">
        <i className={`fas ${icon}`} />
      </span>
    </div>
    {(active || touched) && ((error && <span><p className="help is-danger">{error}</p></span>))}
  </label>
);

RenderPasswordField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  icon: PropTypes.string.isRequired,
  input: PropTypes.instanceOf(Object).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    active: PropTypes.bool,
    error: PropTypes.string,
  }),
};

RenderPasswordField.defaultProps = {
  label: undefined,
  name: undefined,
  meta: {
    touched: false,
    active: false,
    error: undefined,
  },
};
